import clsx from 'clsx'
import * as React from 'react'
import { HTMLAttributes } from 'react'
import { Drawer as DrawerPrimitive } from 'vaul'

import Styles from './Drawer.module.scss'

const Drawer = ({
  shouldScaleBackground = true,
  ...props
}: React.ComponentProps<typeof DrawerPrimitive.Root>) => (
  <DrawerPrimitive.Root
    shouldScaleBackground={shouldScaleBackground}
    direction="right"
    {...props}
  />
)
Drawer.displayName = 'Drawer'

const DrawerTrigger = DrawerPrimitive.Trigger

const DrawerPortal = DrawerPrimitive.Portal

const DrawerClose = React.forwardRef<
  React.ElementRef<typeof DrawerPrimitive.Close>,
  React.ComponentPropsWithoutRef<typeof DrawerPrimitive.Close>
>(({ className, ...props }, ref) => (
  <DrawerPrimitive.Close
    data-testid="drawer-close"
    ref={ref}
    className={className}
    {...props}
  />
))
DrawerClose.displayName = DrawerPrimitive.Close.displayName

const DrawerOverlay = React.forwardRef<
  React.ElementRef<typeof DrawerPrimitive.Overlay>,
  React.ComponentPropsWithoutRef<typeof DrawerPrimitive.Overlay>
>(({ className, ...props }, ref) => (
  <DrawerPrimitive.Overlay
    data-testid="drawer-overlay"
    ref={ref}
    className={clsx(Styles.overlay, className)}
    {...props}
  />
))
DrawerOverlay.displayName = DrawerPrimitive.Overlay.displayName

const DrawerContent = React.forwardRef<
  React.ElementRef<typeof DrawerPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof DrawerPrimitive.Content>
>(({ className, ...props }, ref) => (
  <DrawerPortal>
    <DrawerClose asChild>
      <DrawerOverlay />
    </DrawerClose>
    <DrawerPrimitive.Content
      data-testid="drawer-content"
      ref={ref}
      className={clsx(Styles.content, className)}
      {...props}
    />
  </DrawerPortal>
))
DrawerContent.displayName = 'DrawerContent'

const DrawerHeader = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => (
  <div
    className={clsx(Styles.header, className)}
    data-testid="drawer-header"
    {...props}
  />
)
DrawerHeader.displayName = 'DrawerHeader'

const DrawerFooter = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => (
  <div
    className={clsx(Styles.footer, className)}
    data-testid="drawer-footer"
    {...props}
  />
)
DrawerFooter.displayName = 'DrawerFooter'

const DrawerBody = React.forwardRef<
  HTMLDivElement,
  HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={clsx(Styles.body, className)}
    data-testid="drawer-body"
    {...props}
  />
))
DrawerBody.displayName = 'DrawerBody'

export {
  Drawer,
  DrawerBody,
  DrawerClose,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerPortal,
  DrawerTrigger
}
